import { isProductionHostname } from './auth/config';

/**
 * Launch decision 10: every environment but production stays out of search indexes. The SWA
 * serves one static shell everywhere, so the directive is applied at runtime (crawlers that run
 * scripts honour it; the backend's per-environment robots.txt keeps the rest out). Returns the
 * robots meta content to apply, or null on production.
 */
export function robotsDirectiveFor(hostname: string): string | null {
  return isProductionHostname(hostname) ? null : 'noindex, nofollow';
}

/** Adds the directive as a `<meta name="robots">` to the document head; a no-op on production. */
export function applyRobotsMeta(doc: Document, hostname: string): void {
  const directive = robotsDirectiveFor(hostname);
  if (directive === null) return;
  const meta = doc.createElement('meta');
  meta.name = 'robots';
  meta.content = directive;
  doc.head.appendChild(meta);
}
